// @flow
import { getCreator, postCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  GET_FLIGHT: `${environment.apiUrl}/flight/:id/user`,
  SAVE_DATA: `${environment.apiUrl}/flight/:id/user/contact`,
});

export const getFlightApi = getCreator(fetch, endpoints.GET_FLIGHT);
export const saveDataApi = postCreator(fetch, endpoints.SAVE_DATA);



// WEBPACK FOOTER //
// ./src/modules/flight-landing/api.js